import { ReactNode } from "react";

import { Link } from "./Link";

type QuestionLinkProps = {
  children: ReactNode;
  question: string;
  disabled?: boolean;
  inverted?: boolean;
  onClick: () => void;
};

/**
 * A question with the action link stacked below it, e.g. "Ist die
 * E-Mail-Adresse falsch?" + "E-Mail erneut eingeben" in the auth dialogs.
 */
export const QuestionLink = ({
  children,
  question,
  disabled = false,
  inverted = false,
  onClick,
}: QuestionLinkProps) => (
  <div className="flex flex-col items-start gap-2">
    <p className="text-body-lg leading-md">{question}</p>
    <Link disabled={disabled} inverted={inverted} onClick={onClick}>
      {children}
    </Link>
  </div>
);
